// samplingSiteEvents/state.js

export const samplingEventsListInitialState = {
  active: {
    isLoading: true,
    error: null,
    items: [],
    pagination: {
      currentPage: 1,
      totalPages: 1,
      totalEvents: 0,
      eventsPerPage: 10,
    },
    selectedId: null,
  },
  completed: {
    isLoading: true,
    error: null,
    items: [],
    pagination: {
      currentPage: 1,
      totalPages: 1,
      totalEvents: 0,
      eventsPerPage: 10,
    },
    selectedId: null,
  },
};
